import getParent from '@/util/getParent'

export default {
  computed: {
    parentForm () {
      return getParent(this, 'rf-form')
    }
  }
}



// WEBPACK FOOTER //
// ./src/frontend/mixins/parentForm.js